import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import DisplayBox from "components/DisplayBox";
import { TAG_COLORS } from "components/Tags/Tag";
import { BlueprintSummaryTags } from "components/Blueprints";

/**
 * BlueprintSummary
 *
 * The disciplines and skills a blueprint is tagged with, which the role builder card shows customers.
 *
 * @param {Object}    template
 * @param {Boolean}   loading
 * @param {Function}  onEdit    Opens the name and tags form
 */
const BlueprintSummary = ({ template, loading, onEdit, ...props }) => (
  <DisplayBox
    title={<FormattedMessage id="Blueprints.Summary.Title" />}
    data={SUMMARY_DATA(template)}
    numColumns={2}
    loading={loading}
    isEditable
    onEdit={onEdit}
    {...props}
  />
);

const SUMMARY_DATA = (template) => [
  {
    title: <FormattedMessage id="Blueprints.Summary.Disciplines" />,
    body: template?.disciplines?.length > 0 && (
      <BlueprintSummaryTags tags={template.disciplines} {...TAG_COLORS.purple} />
    ),
  },
  {
    title: <FormattedMessage id="Blueprints.Summary.Skills" />,
    body: template?.primarySkills?.length > 0 && (
      <BlueprintSummaryTags tags={template.primarySkills} {...TAG_COLORS.pink} />
    ),
  },
];

BlueprintSummary.propTypes = {
  template: PropTypes.shape({
    disciplines: PropTypes.array,
    primarySkills: PropTypes.array,
  }),
  loading: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
};

export default BlueprintSummary;
